import { useStyletron } from '@thanx/uikit/theme'
import Select from 'components/Form/Select'
import React, { useMemo } from 'react'

// Wraps the project-standard `components/Form/Select` (react-select) with
// the call site we want for filter dropdowns: a string `value`,
// derived-from-data string options, plain string `onChange`. Keeps the
// filter state in LocationsTab as scalar strings (matches sort/search/
// pagination state) instead of leaking react-select's Option<T> shape.
type FilterOption = { value: string; label: string }

type Props = {
  label: string
  value: string
  options: readonly string[]
  onChange: (next: string) => void
  disabled?: boolean
}

const FilterSelect = ({
  label,
  value,
  options,
  onChange,
  disabled = false,
}: Props) => {
  const [css] = useStyletron()
  const opts: FilterOption[] = useMemo(
    () => options.map(o => ({ value: o, label: o })),
    [options]
  )
  const selected = value ? { value, label: value } : null
  return (
    <div className={css({ width: '180px' })}>
      <Select
        aria-label={label}
        placeholder={label}
        isDisabled={disabled}
        isClearable
        options={opts}
        value={selected}
        onChange={(opt: FilterOption | null) => onChange(opt?.value ?? '')}
      />
    </div>
  )
}

export default FilterSelect
